import { render } from "./loanNotesDialog.vue?vue&type=template&id=279d96f6"
import script from "./loanNotesDialog.vue?vue&type=script&lang=js"
export * from "./loanNotesDialog.vue?vue&type=script&lang=js"

import "./loanNotesDialog.vue?vue&type=style&index=0&id=279d96f6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__